import { useLaunchpadProvider, usePool } from '@trustpad/launchpad';

import { useEffect, useState } from 'react';

import { call } from '~utils';

export function useLotteryWinnersPicked() {
  const {
    saleInstance,
    pool: { sale },
  } = usePool();
  const { levels } = useLaunchpadProvider();
  const lotteryLevel = Object.values(levels).find((l) => l.random);
  const [picked, setPicked] = useState(sale.baseAllocation.gtn(0));

  useEffect(() => {
    if (!lotteryLevel) return;
    if (sale.baseAllocation.gtn(0)) {
      setPicked(true);
      return;
    }

    call(saleInstance, 'getLevelWinners', [lotteryLevel.id]).then((addresses) =>
      setPicked(addresses.length > 0),
    );
  }, [saleInstance, sale.baseAllocation, lotteryLevel?.id]);

  return picked;
}
